// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"437":"2872d900","543":"c8fec544","553":"5538bc1a","680":"8976e618","715":"0d2fecdb","768":"4c2e008d","876":"dc347163","881":"712b2999"}[chunkId] + ".chunk.js";
};